import React from 'react';
import { CreateOrderOnboardingCard } from '@/components/create-order-onboarding-card';

export interface Props {
  onNewOrderPress: () => void;
}

// TODO: use create order card directly
export const OrdersEmptyState: React.FC<Props> = ({ onNewOrderPress }) => {
  // Restaurant is active and has suppliers, display create order card
  return <CreateOrderOnboardingCard onButtonPress={onNewOrderPress} />;
};
